<template>
<div :class="['recipe-source-site-wrapper', { visible: this.recipeSource.visible }]">
  <div class="recipe-source-btn-wrapper">
    <BaseButton type="button" class="btn-small btn-clear" @click="this.hide">
      Close
    </BaseButton>
  </div>
  <iframe v-if="this.recipeSource.source" :src="this.recipeSource.source"></iframe>
</div>
</template>

<script>
import store from '@state/store';
import { recipesComputed, recipesMethods } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...recipesComputed,
  },
  mounted() {},
  methods: {
    ...recipesMethods,
    hide() {
      this.setRecipeSource({ source: null, visible: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.recipe-source-site-wrapper {
  background-color: white;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  visibility: hidden;
  z-index: 9999;

  &.visible {
    visibility: visible;
  }

  .recipe-source-btn-wrapper {
    border-bottom: 1px solid lighten($color-lightGrey, 40);
    padding: 1rem 0;

    .button.btn-clear.btn-clear {
      color: $color-lightGrey !important;
      margin: 0;
    }
  }

  iframe {
    border: none;
    height: 100%;
    width: 100%;
  }
}
</style>
